module.exports = __webpack_public_path__ + "img/translator_ch.e058850.svg";